<template>
  <div id="app">
    <mr-navbar></mr-navbar>
    <graduate-presentation></graduate-presentation>
<!--    <news></news>-->
    <our-services></our-services>
    <weekly-schedule></weekly-schedule>
    <lesson-schedule></lesson-schedule>
    <forms></forms>

    <team></team>
    <list-thesis-doctors></list-thesis-doctors>
    <list-thesis-vue-route></list-thesis-vue-route>
<contact></contact>
  </div>
</template>
<script>
import MrNavbar from "./components/MrNavbar";
import GraduatePresentation from "./components/GraduatePresentation";
import OurServices from "./components/OurServices";
import Forms from "./components/Forms";
import Team from "./components/Team";
// import News from "@/components/News";
import WeeklySchedule from "@/components/WeeklySchedule";
import ListThesisVueRoute from "@/components/ListThesises/ListThesisVueRoute";
import ListThesisDoctors from "@/components/ListThesisDoctors";
import Contact from "@/components/Contact";
import LessonSchedule from "./components/LessonSchedule";
export default {
  name: 'Home',
  components: {
    Contact,
    ListThesisDoctors,
    ListThesisVueRoute,
    WeeklySchedule,
    // News,
    Team,
    Forms,
    OurServices,
    GraduatePresentation,
    MrNavbar,
    LessonSchedule
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
